import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { UserContextService } from './user-context.service';
import { UserContextInterceptor } from './user-context.interceptor';

@NgModule({
  providers: [
    UserContextService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UserContextInterceptor,
      multi: true,
    },
  ],
})
export class UserContextModule {}
